module.exports = __webpack_public_path__ + "static/semavatar-a33d99af8c34c3791534b1c31450a204.jpg";